export default __webpack_public_path__ + "static/media/detail.06211e3e.svg";